import { useReducer } from "react";

export interface UploadUIState {
  isDragging: boolean;
  isUploading: boolean;
  uploadProgress: number;
  uploadError: string;
  detailedMessages: string[];
  showSuccessPopup: boolean;
  showErrorPopup: boolean;
}

export type UploadUIAction =
  | { type: "SET_DRAGGING"; payload: boolean }
  | { type: "START_UPLOAD" }
  | { type: "SET_PROGRESS"; payload: number }
  | { type: "UPLOAD_SUCCESS" }
  | { type: "UPLOAD_ERROR"; payload: string; detailedMessages?: string[] }
  | { type: "RESET_PROGRESS" }
  | { type: "CLOSE_SUCCESS_POPUP" }
  | { type: "CLOSE_ERROR_POPUP" };

export const initialUploadUIState: UploadUIState = {
  isDragging: false,
  isUploading: false,
  uploadProgress: 0,
  uploadError: "",
  detailedMessages: [],
  showSuccessPopup: false,
  showErrorPopup: false,
};

export function uploadUIReducer(state: UploadUIState, action: UploadUIAction): UploadUIState {
  switch (action.type) {
    case "SET_DRAGGING":
      return { ...state, isDragging: action.payload };
    case "START_UPLOAD":
      return {
        ...state,
        isUploading: true,
        uploadError: "",
        uploadProgress: 0,
        detailedMessages: [],
        showSuccessPopup: false,
        showErrorPopup: false,
      };
    case "SET_PROGRESS":
      return { ...state, uploadProgress: action.payload };
    case "UPLOAD_SUCCESS":
      return { ...state, isUploading: false, uploadProgress: 100, showSuccessPopup: true, showErrorPopup: false };
    case "UPLOAD_ERROR":
      return {
        ...state,
        isUploading: false,
        uploadProgress: 0,
        uploadError: action.payload,
        detailedMessages: action.detailedMessages ?? [],
        showErrorPopup: true,
        showSuccessPopup: false,
      };
    case "RESET_PROGRESS":
      return { ...state, uploadProgress: 0 };
    case "CLOSE_SUCCESS_POPUP":
      return { ...state, showSuccessPopup: false };
    case "CLOSE_ERROR_POPUP":
      return { ...state, showErrorPopup: false, uploadError: "" };
    default:
      return state;
  }
}

export function useUploadReducer() {
  return useReducer(uploadUIReducer, initialUploadUIState);
}
